import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21v-12","key":"svg-0"}],["path",{"d":"M8 13l4 -4l4 4","key":"svg-1"}],["path",{"d":"M21 12a9 9 0 0 0 -18 0","key":"svg-2"}]]

/**
 * IconArrowUpToArc
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctdXAtdG8tYXJjIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0xMiAyMXYtMTIiIC8+CiAgPHBhdGggZD0iTTggMTNsNCAtNGw0IDQiIC8+CiAgPHBhdGggZD0iTTIxIDEyYTkgOSAwIDAgMCAtMTggMCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-up-to-arc
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowUpToArc = createReactComponent('outline', 'arrow-up-to-arc', 'ArrowUpToArc', __iconNode);

export default IconArrowUpToArc;